import { render, staticRenderFns } from "./PayrollReceipt.vue?vue&type=template&id=fd6e4702"
import script from "./PayrollReceipt.vue?vue&type=script&lang=js"
export * from "./PayrollReceipt.vue?vue&type=script&lang=js"
import style0 from "./PayrollReceipt.vue?vue&type=style&index=0&id=fd6e4702&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports